import _map from 'lodash/map';
import {DateTime} from 'luxon';
import ObjectStatus from '../enums/static/ObjectStatus';
import {
  DataSource,
  DataSourceStatistics,
  PixelData,
  RemoteDataSource,
  RemoteDataSourceStatistics,
} from './dataSources.types';

export function DataSourcesToClientModel(dataSources: RemoteDataSource[]): DataSource[] {
  return _map(dataSources, (ds) => ({
    ...ds,
    isActive: ds.status === ObjectStatus.Active,
    creation: DateTime.fromISO(ds.creation),
  }));
}

export function toDataSourceStatisticsPixelData(pixelData: PixelData): DataSourceStatistics {
  return {
    date: null,
    countPerEventType: pixelData?.eventToCountDic,
    datasourceId: +pixelData.pixelId,
    totalCount: pixelData.totalEventCount,
    name: pixelData.name,
    timeToEventCountDic: pixelData.timeToEventCountDic,
    timeToTotalEventDic: pixelData.timeToTotalEventDic,
    eventToParametersRecievedCounts: pixelData.eventToParametersRecievedCounts,
  };
}

export function toClientDataSourceStatistics(
  remoteStats: RemoteDataSourceStatistics,
): DataSourceStatistics {
  return {
    ...remoteStats,
    date: DateTime.fromISO(remoteStats.date),
  };
}
